// Each repeated value crosses the RSC boundary once. JSON keys preserve list
// order and distinguish empty arrays, nulls, and different offer destinations.
export const packingPool = <T>() => {
  const values: T[] = []
  const positions = new Map<string, number>()
  const intern = (value: T): number => {
    const key = JSON.stringify(value)
    const existing = positions.get(key)
    if (existing !== undefined) {
      return existing
    }
    const index = values.length
    positions.set(key, index)
    values.push(value)
    return index
  }
  return { values, intern }
}
